// import _ from 'lodash';
// import moment from 'moment';
import * as Actions from '../../actions/repairOrder/type';
import * as EstimateActions from '../../actions/estimate/type';
import * as ProblemActions from '../../actions/problems/type';

const initialState = {
  createdJob: {},
  generateROSuccess: '',
  generateROError: '',
  roList: [],
  roData: {},
  createConcernJobLoader: false,
  createTechRecJobLoader: false,
  generateROLoading: false,
  roListingLoader: false,
  accountRecievable: false,

  roLoader: false,
  error: '',
  createJobErr: '',
  estimatedTotal: {}, // for side bar
  // get authorization history

  getAuthHistoryLoading: false,
  getAuthHistoryData: '',
  getAuthHistoryError: false,

  getPurchasesLoading: false,
  purchases: [],
  getPurchasesErr: '',

  updateROLoading: false,
  updateROSuccess: '',
  updateROError: '',

  getMediaAttachmentsLoading: false,
  getMediaAttachments: [],
  getMediaAttachmentsError: false,

  shareRoPdfLoading: false,
  shareRoPdfSuccess: '',
  shareRoPdfError: '',
  nexPart: [],
  // if ro approved jobs are completed and fully paid then 'locked' will be true
  lockedLoader: false,
  locked: false,
  lockedErr: '',

  // update ro stage
  updateRoStageLoader: false,
  updateRoStageSuccess: '',
  updateRoStageError: '',

  // when user click on Send buuton in  Ro attachment in side bar of RO
  openEmailPopup: false,
  attachmentUrls: [], // contains ro attachment url s
};

export const RoReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.OPEN_EMAIL_POPUP:
      return {
        ...state,
        openEmailPopup: true,
        attachmentUrls: action.payload,
      };
    case Actions.CLEAR_OPEN_EMAIL_POPUP_STATES:
      return {
        ...state,
        openEmailPopup: false,
        attachmentUrls: [],
      };

    case Actions.JOB_BOARD_SMS_DATA:
      return {
        ...state,
        jobboardSmsData: {
          roId: action.payload.roId,
          customer: action.payload.customer,
        },
      };
    case Actions.INCREASE_JOB_BOARD_SMS_DATA:
      return {
        ...state,
        jobboardSmscount: (+state.jobboardSmscount || 0) + action.payload,
      };
    case Actions.CLEAR_JOB_BOARD_SMS_DATA:
      return {
        ...state,
        jobboardSmsData: null,
      };
    case Actions.CLEAR_INCREASE_JOB_BOARD_SMS_DATA:
      return {
        ...state,
        jobboardSmscount: 0,
      };
    // Create RO

    case Actions.CREATE_RO_JOB_REQUEST:
      return {
        ...state,
        // diffrentiating loaders
        createConcernJobLoader:
          action?.problemType === 'customerConcern' ? true : false,
        createTechRecJobLoader:
          action?.problemType === 'techRecommendation' ? true : false,
      };
    case Actions.CREATE_RO_JOB_SUCCESS:
      return {
        ...state,
        createConcernJobLoader: false,
        createTechRecJobLoader: false,
        createdJob: action?.payload,
        // following will work after creation job and set updated data to local state
        // status of created jobs
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            concerns: action?.payload?.data?.concerns || [],
            recommendations: action?.payload?.data?.recommendations || [],
          },
        },
      };
    case Actions.CREATE_RO_JOB_FAIL:
      return {
        ...state,
        createConcernJobLoader: false,
        createTechRecJobLoader: false,
        createJobErr: action.payload,
      };

    // Generate RO
    case Actions.GENERATE_RO_REQUEST:
      return {
        ...state,
        generateROLoading: true,
      };
    case Actions.GENERATE_RO_SUCCESS:
      return {
        ...state,
        generateROLoading: false,
        generateROSuccess: action?.payload,
        success: true,
      };
    case Actions.GENERATE_RO_FAIL:
      return {
        ...state,
        generateROLoading: false,
        generateROError: action.payload,
      };

    // Get ro listing
    case Actions.GET_RO_LISTING_REQUEST:
      return {
        ...state,
        roListingLoader: true,
      };
    case Actions.GET_RO_LISTING_SUCCESS:
      return {
        ...state,
        roListingLoader: false,
        roList: action?.payload?.data?.ro || [],
        count: action?.payload?.count || 0,
        totalCount: action?.payload?.totalCount,
      };
    case Actions.GET_RO_LISTING_FAIL:
      return {
        ...state,
        roListingLoader: false,
        error: action.payload,
      };

    // Get RO Authorization History
    case Actions.GET_AUTHORIZATION_HISTORY_REQUEST:
      return {
        ...state,
        getAuthHistoryLoading: true,
      };
    case Actions.GET_AUTHORIZATION_HISTORY_SUCCESS:
      return {
        ...state,
        getAuthHistoryLoading: false,
        getAuthHistoryData: action?.payload?.data || '',
      };

    case Actions.GET_AUTHORIZATION_HISTORY_FAIL:
      return {
        ...state,
        getAuthHistoryLoading: false,
        getAuthHistoryError: action.payload,
      };

    // Get ro by id
    case Actions.GET_RO_REQUEST:
      return {
        ...state,
        roLoader: true,
      };
    case Actions.GET_RO_SUCCESS:
      return {
        ...state,
        roLoader: false,
        roData: action?.payload?.data || [],
        accountRecievable:
          action?.payload?.data?.ro?.invoice?.accountReceivable || false,
      };
    case Actions.GET_RO_SUCCESS_LOADER_OFF:
      return {
        ...state,
        roLoader: false,
      };
    case Actions.UPDATE_INVOICE_IN_RO:
      return {
        ...state,
        roLoader: false,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            invoice: action.payload,
          },
        },
      };

    case Actions.ADD_NEW_VEHICLE_TO_RO:
      return {
        ...state,

        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            vehicle: action.payload,
          },
        },
      };
    case EstimateActions.UPDATE_ESTIMATE_STATE: // update ro state on creating estimate
      return {
        ...state,

        roData: {
          ...state.roData,
          estimateData: action?.estimateData?.data || {},
          estimateCreated: action?.estimateData?.data ? true : false,
        },
      };
    case EstimateActions.ESTIMATED_TOTAL_STATE: // update ro state on creating estimate
      return {
        ...state,
        estimatedTotal: action.estimatedTotal,
      };
    case Actions.UPDATE_RO_SELECTED_VEHICLE:
      return {
        ...state,

        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            vehicle: action.payload,
          },
        },
      };

    // filter inspections on delete
    case Actions.DELETE_INSPECTIONS_SUCCESS:
      return {
        ...state,

        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            inspections: [
              ...(state?.roData?.ro?.inspections?.filter(
                (f) => f.id !== action.payload,
              ) || []),
            ],
          },
        },
      };

    // Get Inspection PDF Data

    case Actions.GET_INSPECTION_PDF_DATA_REQUEST:
      return {
        ...state,
        getInspPdfDataLoading: true,
      };
    case Actions.GET_INSPECTION_PDF_DATA_SUCCESS:
      return {
        ...state,
        getInspPdfDataLoading: false,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            ...(action.payload?.data?.ro || ''),
          },
        },
      };

    case Actions.GET_INSPECTION_PDF_DATA_FAIL:
      return {
        ...state,
        getInspPdfDataLoading: false,
      };

    // update selected vehicle images
    case Actions.UPDATE_VEHICLE_IMAGES:
      let vehicleData = state.roData?.ro?.vehicle || '';

      if (vehicleData?.id === action.payload.data?.id) {
        vehicleData = {
          ...vehicleData,
          ...(action.payload.data || ''),
        };
      }
      return {
        ...state,

        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            vehicle: vehicleData,
          },
        },
      };

    case Actions.UPDATE_RO_SELECTED_CUSTOMER:
      return {
        ...state,

        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            customer: action.payload,
          },
        },
      };

    // Get RO Authorization History
    case Actions.GET_PURCHASES_REQUEST:
      return {
        ...state,
        getPurchasesLoading: true,
      };
    case Actions.GET_PURCHASES_SUCCESS:
      return {
        ...state,
        getPurchasesLoading: false,
        purchases: action?.payload?.data || '',
      };

    case Actions.GET_PURCHASES_FAIL:
      return {
        ...state,
        getPurchasesLoading: false,
        getPurchasesErr: action.payload,
      };

    // update selected customer vehicles when vehicle added/updated successfully

    case Actions.UPDATE_RO_SELECTED_CUSTOMER_VEHICLES:
      const { addNewVehicle } = action.payload;

      let vehicles = state?.roData?.ro?.customer?.vehicles || [];

      if (addNewVehicle) {
        // adding new vehicle to customer vehicles list
        vehicles = [...vehicles, action.payload];
      } else {
        // updating vehicle to customer vehicles list

        const vehicle = action.payload || ''; // updated vehicle

        if (vehicle?.id) {
          const foundIndex = vehicles?.findIndex((v) => v.id === vehicle.id);

          if (foundIndex > -1) {
            vehicles[foundIndex] = vehicle;
          }
        }
      }

      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            customer: {
              ...state.roData.ro.customer,
              vehicles,
            },
          },
        },
      };

    // update ro pdf urls
    case Actions.UPDATE_RO_PDF_URLS:
      return {
        ...state,
        roData: {
          ...state.roData,
          pdfUrls: {
            ...(state.roData?.pdfUrls || ''),
            [action.payload.type]: action.payload.url,
          },
        },
      };
    case Actions.GET_RO_FAIL:
      return {
        ...state,
        roLoader: false,
        error: action.payload,
      };

    // Update RO
    case Actions.UPDATE_RO_REQUEST:
      return {
        ...state,
        updateROLoading: true,
      };
    case Actions.UPDATE_RO_SUCCESS:
      return {
        ...state,
        updateROLoading: false,
        updateROSuccess: action?.payload || 'Repair Order Updated Succesfully.',
      };
    case Actions.UPDATE_RO_FAIL:
      return {
        ...state,
        updateROLoading: false,
        updateROError: action.payload,
      };

    case Actions.CLEAR_UPDATE_RO_STATE:
      return {
        ...state,
        updateROLoading: false,
        updateROSuccess: '',
        updateROError: '',
      };

    // Delete RO
    case Actions.DELETE_RO_REQUEST:
      return {
        ...state,
        deleteroLoading: true,
      };
    case Actions.DELETE_RO_SUCCESS:
      const roList = state?.roList || [];
      const filteredRoList = roList?.filter(
        (ro) => ro.id !== action?.payload?.data?.id,
      );
      return {
        ...state,
        deleteroLoading: false,
        deletedRo: action?.payload?.data || {},
        roList: [...filteredRoList],
      };
    case Actions.DELETE_RO_FAIL:
      return {
        ...state,
        deleteroLoading: false,
        deleteRoError: action.payload,
      };
    case Actions.CLEAR_DELETED_RO_STATE:
      return {
        ...state,
        deletedRo: {},
      };

    // ...............................get all ro comments
    case Actions.GET_ALL_COMMENTS_REQUEST:
      return {
        ...state,
        getCommentsLoader: true,
      };
    case Actions.GET_ALL_COMMENTS_SUCCESS:
      return {
        ...state,
        getCommentsLoader: false,
        commentsData: action.payload?.data || [],
      };
    case Actions.GET_ALL_COMMENTS_FAIL:
      return {
        ...state,
        getCommentsLoader: false,
        commentsErr: action.payload,
      };

    // .........................create comment
    case Actions.CREATE_COMMENT_REQUEST:
      return {
        ...state,
        commentLoader: true,
      };
    case Actions.CREATE_COMMENT_SUCCESS:
      return {
        ...state,
        commentLoader: false,
        newComment: action.payload?.data || {},
      };
    case Actions.CREATE_COMMENT_FAIL:
      return {
        ...state,
        commentLoader: false,
        commentErr: action.payload,
      };

    // .........................update comment
    case Actions.UPDATE_COMMENT_REQUEST:
      return {
        ...state,
        updateCommentLoader: true,
      };
    case Actions.UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        updateCommentLoader: false,
        updatedComment: action.payload?.data || {},
      };
    case Actions.UPDATE_COMMENT_FAIL:
      return {
        ...state,
        updateCommentLoader: false,
        updateCommentErr: action.payload,
      };

    // .........................REPLY TO comment
    case Actions.SEND_REPLY_REQUEST:
      return {
        ...state,
        replyCommentLoader: true,
      };
    case Actions.SEND_REPLY_SUCCESS:
      return {
        ...state,
        replyCommentLoader: false,
        replyData: action.payload?.data || {},
      };
    case Actions.SEND_REPLY_FAIL:
      return {
        ...state,
        replyCommentLoader: false,
        replyCommentErr: action.payload,
      };

    // .........................update reply
    case Actions.UPDATE_REPLY_REQUEST:
      return {
        ...state,
        updateReplyLoader: true,
      };
    case Actions.UPDATE_REPLY_SUCCESS:
      return {
        ...state,
        updateReplyLoader: false,
        updatedReply: action.payload?.data || {},
      };
    case Actions.UPDATE_REPLY_FAIL:
      return {
        ...state,
        updateReplyLoader: false,
        updateReplyErr: action.payload,
      };

    // .........................delete comment
    case Actions.DELETE_COMMENT_REQUEST:
      return {
        ...state,
        deleteCommentLoader: true,
      };
    case Actions.DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        deleteCommentLoader: false,
        deletedComment: action.payload?.data || {},
      };
    case Actions.DELETE_COMMENT_FAIL:
      return {
        ...state,
        deleteCommentLoader: false,
        deletedCommentErr: action.payload,
      };

    // .........................delete reply
    case Actions.DELETE_REPLY_REQUEST:
      return {
        ...state,
        deleteReplyLoader: true,
      };
    case Actions.DELETE_REPLY_SUCCESS:
      return {
        ...state,
        deleteReplyLoader: false,
        deletedReply: action.payload?.data || {},
      };
    case Actions.DELETE_REPLY_FAIL:
      return {
        ...state,
        deleteReplyLoader: false,
        deletedReplytErr: action.payload,
      };

    // ...............................getting all messages
    case Actions.GET_ALL_MESSAGES_REQUEST:
      return {
        ...state,
        getMessagesLoader: true,
      };
    case Actions.GET_ALL_MESSAGES_SUCCESS:
      return {
        ...state,
        getMessagesLoader: false,
        messages: action.payload?.data || [],
      };
    case Actions.GET_ALL_MESSAGES_FAIL:
      return {
        ...state,
        getMessagesLoader: false,
        messageErr: action.payload,
      };

    // ...............................sending message against ro
    case Actions.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        messageLoader: true,
      };
    case Actions.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        messageLoader: false,
        newMessage: action.payload?.data || {},
      };
    case Actions.SEND_MESSAGE_FAIL:
      return {
        ...state,
        messageLoader: false,
        messageErr: action.payload,
      };

    // ...............................sending email against ro
    case Actions.SEND_EMAIL_REQUEST:
      return {
        ...state,
        emailLoader: true,
      };
    case Actions.SEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailLoader: false,
        newEmail: action.payload?.data || {},
      };
    case Actions.SEND_EMAIL_FAIL:
      return {
        ...state,
        emailLoader: false,
        emailErr: action.payload,
      };

    // ...............................getting all emails
    case Actions.GET_ALL_EMAIL_REQUEST:
      return {
        ...state,
        getEmailsLoader: true,
      };
    case Actions.GET_ALL_EMAIL_SUCCESS:
      return {
        ...state,
        getEmailsLoader: false,
        emails: action.payload?.data || [],
      };
    case Actions.GET_ALL_EMAIL_FAIL:
      return {
        ...state,
        getEmailsLoader: false,
        emailsErr: action.payload,
      };

    // ...............................getting media attachments
    case Actions.GET_MEDIA_ATTACHMENTS_REQUEST:
      return {
        ...state,
        getMediaAttachmentsLoading: true,
      };
    case Actions.GET_MEDIA_ATTACHMENTS_SUCCESS:
      // let data = action.payload?.data || [];
      // const groupedData = [];
      // if (data?.length) {
      //   data =
      //     _.groupBy(data, (a) => {
      //       return moment(a.createdAt).format('DD/MM/YYYY ');
      //     }) || '';

      //   data = _.values(data);

      //   data.forEach((dayWiseData) => {
      //     dayWiseData = dayWiseData.map((item) => {
      //       return {
      //         ...item,
      //         time: moment(item?.createdAt).format('HH:mm'),
      //       };
      //     });
      //     let timeWiseData =
      //       _.groupBy(dayWiseData, (a) => {
      //         return a.time;
      //       }) || '';

      //     timeWiseData = _.values(timeWiseData);
      //     groupedData.push({
      //       ...(moment(dayWiseData[0]?.createdAt).format('MM/DD/YYYY') ===
      //       moment().format('MM/DD/YYYY')
      //         ? { date: 'Today' }
      //         : {
      //             date: moment(dayWiseData[0].createdAt).format('MM/DD/YYYY'),
      //           }),

      //       day: moment(dayWiseData[0].createdAt).format('ddd'),

      //       timeWiseData,
      //     });
      //   });
      // }

      return {
        ...state,
        getMediaAttachmentsLoading: false,
        getMediaAttachments: action.payload?.data || [],
      };
    case Actions.GET_MEDIA_ATTACHMENTS_FAIL:
      return {
        ...state,
        getMediaAttachmentsLoading: false,
        getMediaAttachmentsError: action.payload,
      };

    // ...............................share ro pdfs
    case Actions.SHARE_RO_PDF_REQUEST:
      return {
        ...state,
        shareRoPdfLoading: true,
      };
    case Actions.SHARE_RO_PDF_SUCCESS:
      return {
        ...state,
        shareRoPdfLoading: false,
        shareRoPdfSuccess: action.payload,
      };
    case Actions.SHARE_RO_PDF_FAIL:
      return {
        ...state,
        shareRoPdfLoading: false,
        shareRoPdfError: action.payload,
      };
    case Actions.CLEAR_SHARE_RO_PDF_STATES:
      return {
        ...state,
        shareRoPdfLoading: false,
        shareRoPdfSuccess: '',
        shareRoPdfError: '',
      };

    // ...............................getting all RO cards
    case Actions.GET_RO_JOB_CARDS_REQUEST:
      return {
        ...state,
        getJobCardsLoader: true,
      };
    case Actions.GET_RO_JOB_CARDS_SUCCESS:
      return {
        ...state,
        getJobCardsLoader: false,
        jobCards: action.payload?.jobcards || [],
      };
    case Actions.GET_RO_JOB_CARDS_FAIL:
      return {
        ...state,
        getJobCardsLoader: false,
        jobCardErr: action.payload,
      };

    // ...............................updating  RO cards
    case Actions.UPDATE_RO_JOB_CARD_REQUEST:
      return {
        ...state,
        updateJobCardLoader: true,
      };
    case Actions.UPDATE_RO_JOB_CARD_SUCCESS:
      return {
        ...state,
        updateJobCardLoader: false,
        updatedJobCard: action.payload?.jobcards || [],
      };
    case Actions.UPDATE_RO_JOB_CARD_FAIL:
      return {
        ...state,
        updateJobCardLoader: false,
        jobCardErr: action.payload,
      };

    case Actions.UPDATE_CARD_STATUS:
      const jobCardsData = state?.jobCards;
      const columnData = jobCardsData?.find((jb) => jb.id === action?.columnId);
      if (action?.orderStage === 'Removed') {
        // deleting card from state
        columnData[columnData?.name] = columnData[columnData?.name]?.filter(
          (ro) => ro.id !== action?.roId,
        );
      } else {
        const cardIndex = columnData[columnData?.name]?.findIndex(
          (cr) => cr?.id === action?.roId,
        );

        columnData[columnData?.name][cardIndex] = {
          ...columnData[columnData?.name][cardIndex],
          orderStage: action?.orderStage,
        };
      }

      return {
        ...state,
        jobCards: jobCardsData || [],
      };

    // ...............................clearing communications states
    case Actions.CLEAR_COMMUNICATIONS_STATES:
      return {
        ...state,
        newComment: {},
        updatedComment: {},
        deletedComment: {},
        // clearing messages
        newMessage: {},
        messageErr: '',
        newEmail: {},
        emailErr: '',
        newAttachment: {},
        replyData: {},
        updatedReply: {},
        deletedReply: {},
      };

    // ...............................getting general Info for sidebar
    case Actions.GET_GENERAL_INFO_REQUEST:
      return {
        ...state,
        loader: true,
      };
    case Actions.GET_GENERAL_INFO_SUCCESS:
      return {
        ...state,
        loader: false,
        genralInfo: action.payload || [],
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            ...(action.payload?.results || {}),
          },
        },
      };
    case Actions.GET_GENERAL_INFO_FAIL:
      return {
        ...state,
        loader: false,
        err: action.payload,
      };

    // ................................. Update Inspection List
    case Actions.INSPECTION_LIST_UPDATE:
      const { inspections } = state.roData.ro;
      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            inspections: [...inspections, { ...action?.payload }],
          },
        },
      };
    case ProblemActions.UPDATE_CONCERNS_RECOMENDATION_LIST:
      let concerns = state?.roData?.ro?.concerns;
      let recommendations = state?.roData?.ro?.recommendations || [];
      const payloadData = action?.payload?.data;
      if (payloadData?.issueType === 'customerConcern') {
        if (action?.isAdd) {
          concerns = [...concerns, payloadData];
        } else if (action?.isUpdating) {
          const indexOfUpdatedItem = concerns?.findIndex(
            (cnr) => cnr?.id === payloadData?.id,
          );
          const itemToUpdate = concerns[indexOfUpdatedItem];
          concerns[indexOfUpdatedItem] = {
            ...payloadData,

            // it goes unceked becaus status coming from backend is false
            // this is for if user check the concern and update the concern
            // without creating job to check the concern to show user
            checked: itemToUpdate?.checked,
          };
        } else if (action?.isDeleting) {
          concerns = concerns?.filter((cnr) => cnr?.id !== payloadData?.id);
        }
      } else if (action?.isAdd) {
        recommendations = [...recommendations, payloadData];
      } else if (action?.isUpdating) {
        const indexOfUpdatedItem = recommendations?.findIndex(
          (rec) => rec?.id === payloadData?.id,
        );
        const itemToUpdate = recommendations[indexOfUpdatedItem];
        recommendations[indexOfUpdatedItem] = {
          ...payloadData,
          // it goes unceked becaus status coming from backend is false
          // this is for if user check the tech and update the concern
          // without creating job to check the concern to show user
          checked: itemToUpdate?.checked,
          photos: itemToUpdate?.photos || [],
        };
      } else if (action?.isDeleting) {
        recommendations = recommendations?.filter(
          (rec) => rec?.id !== payloadData?.id,
        );
      }

      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            concerns: [...concerns],
            recommendations: [...recommendations],
          },
        },
      };

    // ............................... Update Tech Recommendation List

    case Actions.TECH_RECOMMENDATION_LIST_UPDATE:
      // const { recommendations: techList } = state.roData.ro;
      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            // recommendations: [...techList, ...action?.payload],
            recommendations: [...(action?.payload || [])],
          },
        },
      };

    // updating sidebar data in RO
    case Actions.UPDATE_SIDEBAR_REQUEST:
      return {
        ...state,
        sidebarLoading: true,
      };
    case Actions.UPDATE_SIDEBAR_SUCCESS:
      const payload = { ...action.payload };

      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            ...payload,
          },
        },
        sidebarLoading: false,
      };
    case Actions.UPDATE_SIDEBAR_FAIL:
      return {
        ...state,
        sidebarLoading: true,
      };
    // ............................... Delete Inspection From List On Update

    case Actions.INSPECTION_DELETE_FROM_LIST:
      const { inspections: inspectionList } = state.roData.ro;
      const filteredInspections = inspectionList?.filter(
        (inspection) => inspection.id !== action?.payload,
      );
      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            inspections: [...filteredInspections],
          },
        },
      };

    // ............................... Tech Recommendation Delete From List On Update

    case Actions.TECH_RECOMMENDATION_DELETE_FROM_LIST:
      const { recommendations: recommendationList } = state.roData.ro;
      const filteredRecommendations = recommendationList?.filter(
        (recommendation) => recommendation.inspectionId !== action?.payload,
        //  &&
        // recommendation?.inspectionId,
      );
      return {
        ...state,
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            recommendations: [...filteredRecommendations],
          },
        },
      };
    // nexPart data
    case Actions.NEX_PART_DATA:
      return {
        ...state,
        nexPart: action?.payload || [],
      };

    case Actions.CLEAR_CREATED_JOB_RO_STATES:
      return {
        ...state,
        createdJob: {},
      };
    case Actions.CLEAR_RO_STATES:
      return {
        ...state,

        generateROLoading: false,
        generateROSuccess: '',
        generateROError: '',
        createdJob: {},

        roListingLoader: false,

        roLoader: false,
        roData: {},
        error: '',

        getAuthHistoryLoading: false,
        getAuthHistoryData: '',
        getAuthHistoryError: false,

        updateROLoading: false,
        updateROSuccess: '',
        updateROError: '',
      };

    // update ro sstage

    case Actions.UPDATE_RO_STAGE_REQUEST:
      return {
        ...state,
        updateRoStageLoader: true,
      };
    case Actions.UPDATE_RO_STAGE_SUCCESS:
      return {
        ...state,
        updateRoStageLoader: false,
        updateRoStageSuccess: action.payload?.message || 'Success',

        // update ro order stage
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            orderStage: action.payload?.data?.orderStage || 'N/A',
          },
        },
      };

    // when payemt is done either its partial or fully then update order stage to Ready
    case Actions.UPDATE_RO_STAGE_FROM_PAYMENT:
      return {
        ...state,

        // update ro order stage
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            orderStage: action.payload,
          },
        },
      };

    case Actions.UPDATE_RO_STAGE_FAIL:
      return {
        ...state,
        updateRoStageLoader: false,
        updateRoStageError: action.payload,
      };
    case Actions.CLEAR_UPDATE_RO_STAGE_STATE:
      return {
        ...state,
        updateRoStageLoader: false,
        updateRoStageSuccess: '',
        updateRoStageError: '',
      };

    case Actions.UPDATE_RO_TAG:
      return {
        ...state,

        // update ro order tag
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            roTagId: action.payload?.value,
            roTag: action.payload,
          },
        },
      };

    case Actions.LOCK_RO:
      return {
        ...state,

        // update ro postToReports (locked ro)
        roData: {
          ...state.roData,
          ro: {
            ...state.roData.ro,
            postToReports: action.payload?.postToReports || false,
            completionDate: action.payload?.completionDate || '',
          },
        },
      };

    case Actions.CLEAR__AC__REC:
      return {
        ...state,
        accountRecievable: action?.payload || false,
      };

    default:
      return state;
  }
};
